/* eslint-disable react/prop-types */
import { Icon, Tooltip, Rating } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { getFoodIcon } from "utils/foodIcons";
import { valorAPesos } from "utils/formatters";
import { makeNiceText } from "utils/formatters";

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftBox pl={3} mr={2} display="flex">
              <Tooltip
                title={`${item?.categoriaProducto?.categoria} ${
                  item?.disponibilidad ? "- Disponible" : "- No disponible"
                }`}
                placement="top"
              >
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: item.disponibilidad
                      ? getUproColor("uproGreen")
                      : getUproColor("secondary"),
                  }}
                  fontSize="lg"
                >
                  {getFoodIcon(item?.categoriaProducto?.categoria)}
                </Icon>
              </Tooltip>
              {item.combo && (
                <Tooltip title={`Combo`} placement="top">
                  <Icon
                    sx={{
                      verticalAlign: "middle",
                      cursor: "pointer",
                      color: item.disponibilidad ? getUproColor("uproPink") : "inherit",
                    }}
                    fontSize="lg"
                  >
                    cached
                  </Icon>
                </Tooltip>
              )}
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color={item?.disponibilidad ? "text" : "secondary"}
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <SoftTypography
              variant="caption"
              fontWeight="medium"
              color={item?.disponibilidad ? "text" : "secondary"}
            >
              {item?.nombre ? makeNiceText(item?.nombre) : "Sin nombre"}
            </SoftTypography>
              {item?.ingredientes?.length === 0 && (
                <Tooltip title="El producto no tiene ingredientes" placement="top">
                  <Icon color="error" fontSize="medium">
                    error_outline
                  </Icon>
                </Tooltip>
              )}
              {item?.ingredientes?.some((item) => item?.materiaPrima?.disabled) && (
                <Tooltip title="El producto tiene ingredientes que se encuentran deshabilitados" placement="top">
                  <Icon color="info" fontSize="medium">
                    error_outline
                  </Icon>
                </Tooltip>
              )}
            {typeof item?.valoracionPromedio === "number" && (
              <Rating value={item.valoracionPromedio} precision={0.5} readOnly size="small" />
            )}
          </SoftBox>
        ),
        categoriaProducto: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.categoriaProducto?.categoria}
            </SoftTypography>
          </SoftBox>
        ),
        esElaborado: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.esElaborado ? "Requiere elaboración" : "No requiere elaboración"}
            </SoftTypography>
          </SoftBox>
        ),
        // tipoProducto: (
        //   <SoftBox
        //     onClick={(e) => handleOpenMenu(e, item)}
        //     sx={{
        //       cursor: "pointer",
        //     }}
        //   >
        //     <SoftTypography
        //       verticalAlign="text-top"
        //       variant="caption"
        //       color="secondary"
        //       fontWeight="medium"
        //     >
        //       {item?.tipoProducto?.tipo || "-"}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        precioCarta: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.precioCarta ? valorAPesos(item?.precioCarta) : "Sin precio"}
            </SoftTypography>
          </SoftBox>
        ),
        precioOnline: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.precioOnline ? valorAPesos(item?.precioOnline) : "Sin precio"}
            </SoftTypography>
          </SoftBox>
        ),
        precioCosto: (
          <SoftBox
            onClick={(e) => handleOpenMenu(e, item)}
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.precioCosto ? valorAPesos(item?.precioCosto) : "Sin costo"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            display="flex"
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", align: "left" },
  { name: "nombre", desc: "Nombre", align: "left" },
  // { name: "tipoProducto", desc: "Tipo", align: "left" },
  { name: "categoriaProducto", desc: "Categoria", align: "left" },
  { name: "esElaborado", desc: "Tipo de elaboración", align: "left" },
  { name: "precioCarta", desc: "Precio Carta", align: "left" },
  { name: "precioOnline", desc: "Precio para Llevar", align: "left" },
  { name: "precioCosto", desc: "Costo unitario", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
